var _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path3, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMixed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 95,
    viewBox: "0 0 76 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 76,
    height: 11,
    rx: 2,
    fill: "#4D5053"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    width: 32,
    height: 12,
    rx: 2,
    fill: "#4D5053"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 9,
    width: 16,
    height: 2,
    rx: 1,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C0.895431 4 0 4.89543 0 6V7C0 5.89543 0.895431 5 2 5H74C75.1046 5 76 5.89543 76 7V6C76 4.89543 75.1046 4 74 4H2Z",
    fill: "black",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 78C5 76.3431 6.34315 75 8 75V75C9.65685 75 11 76.3431 11 78V93C11 94.1046 10.1046 95 9 95H7C5.89543 95 5 94.1046 5 93V78Z",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 80,
    width: 6,
    height: 10,
    rx: 1,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 80,
    width: 6,
    height: 10,
    rx: 1,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 77,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 80,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 83,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 86,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 89,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 92,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 78C65 76.3431 66.3431 75 68 75V75C69.6569 75 71 76.3431 71 78V93C71 94.1046 70.1046 95 69 95H67C65.8954 95 65 94.1046 65 93V78Z",
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 77,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 80,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 83,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 86,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 89,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 92,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H72L68.3846 86.4046C68.1691 90.6601 64.6559 94 60.3948 94H15.6052C11.3441 94 7.83089 90.6601 7.61542 86.4045L4 15Z",
    fill: "#4D5053"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3955 94H60.3906C64.6517 94 68.1649 90.6601 68.3804 86.4046L71.9958 15H69.0007L65.3853 86.4046C65.1698 90.6601 61.6566 94 57.3955 94Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15H4L7.61542 86.4045C7.83089 90.6601 11.3441 94 15.6052 94H18.6052C14.3441 94 10.8309 90.6601 10.6154 86.4045L7 15Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 15H4L4.35443 22H71.6456L72 15Z",
    fill: "url(#paint0_linear_176_1031)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3569 87.2155C22.7308 85.3458 24.3725 84 26.2792 84H49.7208C51.6275 84 53.2692 85.3458 53.6431 87.2155L55 94H21L22.3569 87.2155Z",
    fill: "black",
    fillOpacity: 0.15
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.478 87.3492C23.783 85.9766 25.0004 85 26.4065 85H49.5935C50.9996 85 52.217 85.9766 52.522 87.3492L54 94H22L23.478 87.3492Z",
    fill: "#4D5053"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2C22 0.895432 22.8954 0 24 0H52C53.1046 0 54 0.895432 54 2V4H74C75.1046 4 76 4.89543 76 6V13C76 14.1046 75.1046 15 74 15H72L68.3846 86.4046C68.1691 90.6601 64.6559 94 60.3948 94H15.6052C11.3441 94 7.83089 90.6601 7.61542 86.4045L4 15H2C0.895432 15 0 14.1046 0 13V6C0 4.89543 0.895432 4 2 4H22V2Z",
    fill: "url(#paint1_linear_176_1031)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_176_1031)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 40,
    width: 50,
    height: 18,
    rx: 4,
    fill: "black",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9 51.848C26.74 51.272 26.576 50.72 26.408 50.192C26.24 49.664 26.076 49.168 25.916 48.704C25.764 48.232 25.616 47.804 25.472 47.42C25.328 47.036 25.196 46.7 25.076 46.412C25.044 46.868 25.016 47.372 24.992 47.924C24.976 48.468 24.956 49.028 24.932 49.604C24.916 50.18 24.9 50.76 24.884 51.344C24.876 51.92 24.868 52.472 24.86 53H23.828C23.852 52.28 23.876 51.556 23.9 50.828C23.924 50.092 23.952 49.372 23.984 48.668C24.024 47.956 24.064 47.264 24.104 46.592C24.152 45.92 24.204 45.284 24.26 44.684H25.328C25.472 45.028 25.636 45.44 25.82 45.92C26.004 46.392 26.188 46.888 26.372 47.408C26.564 47.928 26.748 48.448 26.924 48.968C27.1 49.488 27.252 49.964 27.38 50.396C27.508 49.964 27.656 49.488 27.824 48.968C27.992 48.448 28.168 47.928 28.352 47.408C28.536 46.888 28.716 46.392 28.892 45.92C29.076 45.44 29.24 45.028 29.384 44.684H30.452C30.508 45.284 30.556 45.92 30.596 46.592C30.644 47.264 30.684 47.956 30.716 48.668C30.756 49.372 30.788 50.092 30.812 50.828C30.836 51.556 30.86 52.28 30.884 53H29.852C29.836 52.472 29.82 51.916 29.804 51.332C29.796 50.748 29.78 50.164 29.756 49.58C29.74 48.988 29.72 48.416 29.696 47.864C29.672 47.304 29.644 46.792 29.612 46.328C29.54 46.528 29.448 46.78 29.336 47.084C29.232 47.38 29.12 47.704 29 48.056C28.888 48.408 28.768 48.772 28.64 49.148C28.52 49.516 28.404 49.872 28.292 50.216C28.188 50.56 28.092 50.876 28.004 51.164C27.924 51.444 27.86 51.672 27.812 51.848H26.9ZM32.715 44.684H33.795V53H32.715V44.684ZM37.6088 47.732L39.0368 44.684H40.1168L38.2208 48.548C38.3888 48.908 38.5648 49.284 38.7488 49.676C38.9408 50.06 39.1248 50.448 39.3008 50.84C39.4848 51.224 39.6568 51.6 39.8168 51.968C39.9768 52.336 40.1168 52.68 40.2368 53H39.1688C39.0808 52.76 38.9768 52.5 38.8568 52.22C38.7448 51.932 38.6168 51.64 38.4728 51.344C38.3368 51.048 38.1928 50.748 38.0408 50.444C37.8968 50.132 37.7528 49.832 37.6088 49.544C37.4648 49.832 37.3168 50.132 37.1648 50.444C37.0128 50.748 36.8688 51.048 36.7328 51.344C36.5968 51.64 36.4688 51.932 36.3488 52.22C36.2368 52.5 36.1408 52.76 36.0608 53H35.0168C35.1288 52.688 35.2648 52.352 35.4248 51.992C35.5848 51.632 35.7528 51.264 35.9288 50.888C36.1048 50.504 36.2808 50.12 36.4568 49.736C36.6408 49.352 36.8168 48.984 36.9848 48.632L35.0648 44.684H36.1688L37.6088 47.732ZM41.4572 53V44.684H45.1892V45.608H42.5372V48.188H44.9372V49.088H42.5372V52.076H45.3812V53H41.4572ZM52.1739 48.836C52.1739 49.612 52.0899 50.272 51.9219 50.816C51.7619 51.352 51.5259 51.788 51.2139 52.124C50.9099 52.46 50.5379 52.704 50.0979 52.856C49.6659 53.008 49.1819 53.084 48.6459 53.084C48.1019 53.084 47.5259 53.012 46.9179 52.868V44.804C47.2219 44.74 47.5179 44.688 47.8059 44.648C48.0939 44.608 48.3699 44.588 48.6339 44.588C49.1779 44.588 49.6659 44.664 50.0979 44.816C50.5379 44.968 50.9099 45.212 51.2139 45.548C51.5259 45.884 51.7619 46.324 51.9219 46.868C52.0899 47.404 52.1739 48.06 52.1739 48.836ZM51.0219 48.836C51.0219 48.244 50.9779 47.74 50.8899 47.324C50.8019 46.908 50.6659 46.568 50.4819 46.304C50.2979 46.04 50.0539 45.848 49.7499 45.728C49.4539 45.608 49.0979 45.548 48.6819 45.548C48.5699 45.548 48.4579 45.552 48.3459 45.56C48.2339 45.568 48.1179 45.58 47.9979 45.596V52.076C48.1179 52.092 48.2339 52.104 48.3459 52.112C48.4579 52.12 48.5659 52.124 48.6699 52.124C49.0939 52.124 49.4539 52.064 49.7499 51.944C50.0459 51.824 50.2859 51.636 50.4699 51.38C50.6619 51.116 50.8019 50.776 50.8899 50.36C50.9779 49.944 51.0219 49.436 51.0219 48.836Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_176_1031",
    x: 12,
    y: 40,
    width: 52,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_176_1031"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_176_1031",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_176_1031",
    x1: 38,
    y1: 15,
    x2: 38,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_176_1031",
    x1: 0,
    y1: 0,
    x2: 76,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixed);
export default __webpack_public_path__ + "static/media/mixed.15029cb153b4e6fe1eb26857225c5156.svg";
export { ForwardRef as ReactComponent };